//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useCallback, useEffect, useContext } from "react";
import { CSVLink } from "react-csv";
import * as moment from "moment";
import { toast } from "react-toastify";

// custom pages
import { styles } from "./styles";
import KpiReport from "apis/kpiReport/KpiReport";
import { DormantRemainderTracker } from "./config/config";
import { toastCss, successCss } from "assets/styleJS/global";
import NoData from "components/Table/NoData";
import Loader from "components/Loader/Loader";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CircularProgress from "@material-ui/core/CircularProgress";

// material-ui icons
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { useTranslation } from 'react-i18next';
import report from "apis/Report/Report";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";



const GlobalCss = withStyles({
    "@global": {
        ".MuiDialog-scrollPaper": {},
        ".MuiDialog-paperWidthSm": {
            overflow: "hidden",
            maxWidth: "none",
        },
        ".MuiDialog-paper ": {},
    },
})(() => null);

export default function DormantRemainderMailTracker(props) {
    const { state, dispatch } = useContext(Context);

    const { page, setDisableDropdown } = props;
 
    const { DormantReaminderMailTrackerAPI } = report();
    const classes = styles();
    const { t, i18n } = useTranslation();


    
    const [states, setstates] = useState({
        columns: [],
        selectedColumns: [],
        selectedFields: [],
        selectedHeaders: [],
        dialog: false,
        data: [],
        response: false,
        quartertype: "",
        emailtype: "",
        year:2025,
        dateApplied: false,
        filterColumn: "",
        filterValue: "",
        filterApplied: false,
        groupBy: "",
        groupByApplied: false,
        pLoading: false,
        eLoading: false,
        errorDialog: false,
        errorCount: "",
    });

    const setStates = useCallback((newState) => {
        setstates((states) => ({ ...states, ...newState }));
    }, []);

    const startYear = 2025; // the year you started
    const currentYear = new Date().getFullYear();
  
    // Generate years from startYear to currentYear
    const years = Array.from(
      { length: currentYear - startYear + 1 },
      (_, i) => startYear + i
    );

    // setting checkboxes
    useEffect(() => {
        let label = DormantRemainderTracker?.columns?.map((c) => c.label);
        setStates({ columns: label, selectedColumns: label });
    }, []);

    // FSCSummary api func
    const handleGetBurn = async () => {
        try {
            setDisableDropdown(true);
            let selectedColumnKeys = [];
              setStates({
                 pLoading: true,
                    eLoading: true
                });

            let selectedObj = [];
            let selectedHeaders = [];

            states.selectedColumns.map(
                (s) => (selectedObj = [...selectedObj, { label: s }])
            );

            DormantRemainderTracker.columns.map((c) => {
                selectedObj.map((s) => {
                    if (c.label === s.label) {
                        selectedHeaders = [...selectedHeaders, c];
                    }
                });
            });

            DormantRemainderTracker.columns.map((c, i) => {
                if (states.selectedColumns?.includes(c.label)) {
                    selectedColumnKeys = [...selectedColumnKeys, c.key];
                    return;
                }
            });

            setStates({
                selectedFields: selectedColumnKeys,
                selectedHeaders: selectedHeaders,
            });

            let values = {
                quartertype:states.quartertype?states.quartertype:"",
                emailtype:states.emailtype?states.emailtype:"",
                year:states.year?states.year:"",
            }
            
            
            let res = await DormantReaminderMailTrackerAPI (values);
            if (res && res?.type === "ERROR") {
                dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
                setStates({
                    pLoading: false,
                    eLoading: false,
                    errorDialog: true,
                    errorCount: res?.count,
                });
                setDisableDropdown(false);
            }
            if (res && res?.data) {
                dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
                setStates({
                    data: res.data,
                    response: true,
                    pLoading: false,
                    eLoading: false,
                });
                setDisableDropdown(false);
                if (res.data.length === 0) {
                    toast.success(t("No Data Found"), { toastId: "no-report-date" });
                      setDisableDropdown(false);
                    return;
                }
                return true;
            }
        } catch (err) {
            console.log(err);
        }
    };
   
    const pointsFormat = (value) => {
        if (value) {
            var nfObject = new Intl.NumberFormat("en-US");
            var points = nfObject.format(value);
            return points;
        }
        return "";
    };

    const pointsDecimalFormat = (value) => {
        if (value) {
            var points = value.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            return points;
        }
        return "";
    };

    return (
        <div>
            <GlobalCss />
            <div className={classes.headText}>
               
               
                        </div>
                        <div className={classes.inputsDiv}>
                            <Grid container spacing={0} style={{gap:"20px"}} >
                            <Grid item xs={12} md={3}>
                        <TextField
                        select
                        label="Select Quarter Type"
                        value={states?.quartertype}
                        onChange={(e) => setStates({ ...states, quartertype: e.target.value })}
                        variant="outlined"
                        style={{ width: '100%', marginBottom: 16 }}
                    >
                        {(states?.year === 2025
                        ? ["Q3", "Q4"]   // only Q3 and Q4 when 2025
                        : ["Q1", "Q2", "Q3", "Q4"] // all quarters for other years
                        ).map((q) => (
                        <MenuItem key={q} value={q}>
                            {q}
                        </MenuItem>
                        ))}
                    </TextField>
                    </Grid>
                    <Grid item xs={12} md={3}>
                    <TextField
                    select
                    label="Select Email Type"
                      value={states?.emailtype}
                      onChange={(e) =>  setStates({ emailtype:e.target.value })}
                    variant="outlined"
                    style={{ width: '100%', marginBottom: 16 , marginLeft:10}}
                    >
                    <MenuItem value="8 Weeks Dormancy Reminder">8 Weeks Dormancy Reminder</MenuItem>
                    <MenuItem value="6 Weeks Dormancy Reminder">6 Weeks Dormancy Reminder</MenuItem>
                    <MenuItem value="4 Weeks Dormancy Reminder">4 Weeks Dormancy Reminder</MenuItem>
                    <MenuItem value="2 Weeks Dormancy Reminder">2 Weeks Dormancy Reminder</MenuItem>
                    <MenuItem value="3 Days Dormancy Reminder">3 Days Dormancy Reminder</MenuItem>
                    <MenuItem value="Post-Dormancy Alert">Post-Dormancy Alert</MenuItem>
                    </TextField> 
                    </Grid>
                    <Grid item xs={12} md={3}>
                    <TextField
                        select
                        label="Select Year"
                        value={states?.year}
                        onChange={(e) => setStates({ year: e.target.value })}
                        variant="outlined"
                        style={{ width: '100%', marginBottom: 16, marginLeft:20}}
                    >
                        {years.map((year) => (
                        <MenuItem key={year} value={year}>
                            {year}
                        </MenuItem>
                        ))}
                    </TextField>
                    </Grid>
                </Grid>
            </div>
            <div style={{ color: "gray", padding: 10 }}>
                {`*Max  file count can be exported ${pointsFormat(800000)}`}
            </div>
            <CSVLink
                id="csv"
                data={states.data}
                headers={states.selectedHeaders}
                skipEmptyLines={true}
                filename={
                    `Dormant Campaign Report` + " " + moment(new Date()).format("MM-DD-YYYY,h:mm A") + ".csv"
                }
                className={classes.CSVlink}
            />
           
                <Button
                    className={classes.exportBtn}
                    onClick={async () => {
                        let missingFields = [];

                        if (!states.quartertype) missingFields.push("Quarter Type");
                        if (!states.emailtype) missingFields.push("Email Type");
                        if (!states.year) missingFields.push("Year");

                        if (missingFields.length > 0) {
                            toast.error(`Please select: ${missingFields.join(", ")}`, {
                                toastId: "empty-fields",
                            });
                            return;
                        }
                        // if (!states.startDate && !states.endDate)  {
                        //     toast.error("Please select the date's",{
                        //         toastId: "empty-fields",
                        //     });
                        //     return;
                        // }
                        // if (states.startDate?.toString() === "Invalid Date" && states.endDate?.toString() === "Invalid Date") {
                        //     toast.error("Invalid date.", {
                        //         toastId: "invalid-date",
                        //     });
                        //     setStates({ startDate: new Date(), endDate: new Date() });
                        //     return;
                        // } 
                        // else if (states.startDate?.toString() === "Invalid Date") {
                        //     toast.error("Invalid date.", {
                        //         toastId: "invalid-s-date",
                        //     });
                        //     setStates({ startDate: new Date() });
                        //     return;
                        // } 
                        // else if (states.endDate?.toString() === "Invalid Date") {
                        //     toast.error("Invalid date.", {
                        //         toastId: "invalid-e-date",
                        //     });
                        //     setStates({ endDate: new Date() });
                        //     return;
                        // }
                        // setStates({ response: false, data: [], eLoading: true });
                        let res = await handleGetBurn();
                        if (res) {
                            let data = [];
                            document.getElementById("csv").click();
                        }
                    }}
                    disabled={states.eLoading || states.pLoading}
                >
                    {states.eLoading ? (
                        <React.Fragment>
                            <CircularProgress
                                style={{ height: 25, width: 25, color: "#fff" }}
                                variant="determinate"
                                value={state.reportResCount}
                            />
                            &nbsp;
                            <span style={{ color: "#fff", fontWeight: "bold" }}>
                                {state.reportResCount == 0 ?
                                <div class="snippet">
                                    <div class="stage">
                                        <div class="dot-typing-e"></div>
                                    </div>
                                </div> 
                                : `${state.reportResCount}%`}
                            </span>
                        </React.Fragment>
                    ) : (
                        "Export CSV"
                    )}
                </Button>
               
               
                <Dialog
                aria-labelledby="simple-dialog-title"
                open={states?.errorDialog}
                style={{ fontFamily: "Segoe-ui" }}
            >
                <div className={classes.dialogParentDiv}>
                    <div style={{ display: "flow-root" }}>
                        <span style={{ float: "right" }}>
                            <HighlightOffIcon
                                style={{
                                    verticalAlign: "-webkit-baseline-middle",
                                    cursor: "pointer",
                                    color: "red",
                                }}
                                onClick={() => {
                                    setStates({ errorDialog: false });
                                }}
                            />
                        </span>
                    </div>
                    <div className={classes.parentText}>
                        {'The date range has fetched'} {states.errorCount} {'records.'} <br />
                        {'Due to Excel/CSV limitation we can only allow for 800,000 recordsfor export.'} <br />
                        {'Please add additional filters to limit your record count to less than 800,000.'}
                    </div>
                </div>
            </Dialog>
        </div>
    );
}
